import React, { Component } from "react";
import { Link } from "gatsby";
import "./NavBar.css";

class NavBar extends Component {
  state = {};
  render() {
    const { active } = this.props;
    return (
      <div className="topnav">
        {/* <div className="logo"> */}
        <h1>Karen Gao</h1>
        <p>Creating the next</p>
        {/* <p>Creating the next</p> */}
        {/* </div> */}
        <Link className={active === "home" ? "active" : ""} to="/">
          Home
        </Link>
        <Link className={active === "projects" ? "active" : ""} to="/projects/">
          Projects
        </Link>

        <Link className={active === "resume" ? "active" : ""} to="/resume/">
          Resume
        </Link>
        <Link className={active === "skills" ? "active" : ""} to="/skills/">
          Skills
        </Link>
        <Link className={active === "contact" ? "active" : ""} to="/contact/">
          Contact
        </Link>
      </div>
    );
  }
}

export default NavBar;
